import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSidemenuLeftClose(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21L5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19L3 5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3L19 3C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5L21 19ZM8 5L5 5L5 19L8 19L8 5ZM10 19L19 19L19 5L10 5L10 19Z"
        fill="currentColor"
      />
      <path
        d="M16 9.00002C16 8.79779 15.8782 8.61547 15.6913 8.53808C15.5045 8.46069 15.2894 8.50346 15.1464 8.64646L12.1464 11.6465C11.9512 11.8417 11.9512 12.1583 12.1464 12.3536L15.1464 15.3536C15.2894 15.4966 15.5045 15.5393 15.6913 15.462C15.8782 15.3846 16 15.2022 16 15L16 9.00002Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
